export const relationshipQl = (name: string) => `
  ${name} {
    data {
      attributes {
        title
        slug
      }
    }
  }
`

export const imagDataQl = () => `
  data {
    attributes {
      url
      alternativeText
      size
      height
      width
    }
    id
  }
  `

export const imageQl = () => `
  image {
    ${imagDataQl()}
  }
`

export const heroImageQl = () => `
  heroImage{
    ${imagDataQl()}
  }
`

export const paginationQl = () => `
  pagination {
    total
    pageCount
    pageSize
    page
  }
`
